import React, { memo, useEffect, useRef, useState } from "react";
import styles from "./Sidebar.module.scss";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { combineClasses, getItem } from "@/lib/utils";
import { toggleSidebar } from "@/store/slices/globalSlice";
// import  toggleSidebar  from "@/store/slices/globalSlice";
import routes from "@/routes/routes";
import ArrowIcon from "@/components/SVGComponents/ArrowIcon";
import type { RootState } from "@/store/rootReducer";
import type { SidebarItem, SidebarChild } from "@/lib/sidebarNavigation";
import { sideBarNavigation } from "@/lib/sidebarNavigation";
import { FiberManualRecord } from "@mui/icons-material";
import { Button } from "@mui/material";
import { setSidebarOpen } from "@/store/slices/globalSlice";

// Define props
interface SidebarProps {
  toggleSidebarOpen: (open: boolean) => () => void;
}

const Sidebar: React.FC<SidebarProps> = ({}) => {
  const sidebarOpen = useSelector(
    (state: RootState) => state.global.sidebarOpen
  );
  const [openDropdown, setOpenDropdown] = useState<string | null>("");
  const dispatch = useDispatch();
  const layoutConf = getItem("layoutConfig");
  const location = useLocation();
  const navigate = useNavigate();
  const myTeam = async () => {
    navigate(routes?.privateRoutes?.MYTEAM?.path ?? "/");
  };

  const openedByHover = useRef(false);

  const toggleDropdown = (id: string) => () => {
    setOpenDropdown((prev) => (prev === id ? "" : id));
  };
  const isRouteActive = (parentPath: string, childPath: string) => {
    const currentPath = location.pathname.replace(/\/+$/, "");
    const fullPath = `${parentPath}/${childPath}`.replace(/\/+$/, "");
    if (childPath === "" && parentPath === currentPath) {
      return true;
    }

    return currentPath === fullPath;
  };

  useEffect(() => {
    if (!sidebarOpen) {
      setOpenDropdown(null);
    }
  }, [sidebarOpen]);

  return (
    <div
      className={combineClasses(
        styles.leftSideContainer,
        // !sidebarOpen ? styles.sidebarClosed : styles.sidebarOpen
      )}
    >
      {/* Logo */}
      <div className={styles.logoContainer}>
        <div className={styles.iconContainer}>
          <div className={styles.mainIconDiv}></div>
        </div>
      </div>
      {/* Navigation */}
      <div
        className={styles.navContainer}
        onMouseOver={() => {
          if (!sidebarOpen) {
            dispatch(setSidebarOpen(true));
            openedByHover.current = true;
          }
        }}
        onMouseLeave={() => {
          if (openedByHover.current) {
            dispatch(setSidebarOpen(false));
            openedByHover.current = false;
          }
        }}
      >
        {sideBarNavigation().map((data: SidebarItem) => {
          const children = data?.children ?? [];

          if (children.length) {
            return (
              <React.Fragment key={data.id}>
                <div
                  onClick={toggleDropdown(data.id)}
                  className={combineClasses(
                    styles.navLink,
                    !sidebarOpen && styles.sidebarClosed,
                    openDropdown === data.id && styles.activeLink
                  )}
                >
                  <div>
                    {data.icon && (
                      <img
                        src={String(data.icon)}
                        alt={data.pageName}
                        width={24}
                        height={24}
                      />
                    )}
                  </div>
                  <div className={styles.linksNames}>
                    {sidebarOpen && (
                      <div className="flex items-center justify-between w-full">
                        <span className={styles.linkPageName}>
                          {data.pageName}
                        </span>
                        <ArrowIcon
                          className={styles.arrowIcon}
                          style={{
                            width: "auto",
                            height: "7px",
                            flexShrink: 0,
                            marginLeft: "auto",
                            transform:
                              openDropdown === data.id
                                ? "rotate(90deg)"
                                : "rotate(0deg)",
                            transition: "transform ease 300ms",
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {openDropdown === data.id && (
                  <div className={styles.submenuContainer}>
                    {children.map((child: SidebarChild) => {
                      const isActive = isRouteActive(data.path, child.path);
                      return (
                        <NavLink
                          key={child.id}
                          to={`${data.path}/${child.path}`}
                          state={{ previousPath: location.pathname }}
                          className={combineClasses(
                            styles.navLink,
                            styles.childNavLink,
                            !sidebarOpen ? styles.sidebarClosed : "",
                            isActive ? styles.activeChildLink : ""
                          )}
                        >
                          <div className={styles.childIcon}>
                            <FiberManualRecord
                              sx={{ fontSize: 7, color: "primary.main" }}
                            />
                          </div>
                          {sidebarOpen && (
                            <p className={styles.childLinkText}>
                              {child.pageName}
                            </p>
                          )}
                        </NavLink>
                      );
                    })}
                  </div>
                )}
              </React.Fragment>
            );
          } else {
            return (
              <NavLink
                key={data.id}
                className={({ isActive }) =>
                  `${styles.navLink} ... ${isActive && styles.activeLink}`
                }
                to={data.path}
                state={{ previousPath: location.pathname }}
                onClick={toggleDropdown("")}
              >
                <div>
                  {data.icon && (
                    <img
                      src={String(data.icon)}
                      alt={data.pageName}
                      width={24}
                      height={24}
                    />
                  )}
                </div>
                <div className={styles.linksNames}>
                  {sidebarOpen && (
                    <p className={styles.linkPageName}>{data.pageName}</p>
                  )}
                </div>
              </NavLink>
            );
          }
        })}
      </div>
    </div>
  );
};

export default memo(Sidebar);
